import { memo } from 'react';
import * as S from './conversations-filter.styles';

import type { TConversationsFilterConfig } from './conversations-filter.types';
import { useConversationsFilterLogic } from './conversations-filter.hook';
import { CONVERSATIONS_FILTER_STRINGS } from './utils/conversations-filter.constants';

const ConversationsFilter = memo(({
	onFilterChange,
}: TConversationsFilterConfig) => {
	const { filterTabs, handleOnClick, selectedTags } = useConversationsFilterLogic({
		onFilterChange,
	});

	return (
		<>
			<S.Wrapper data-qa="conversations-filter">
				{filterTabs.map(tab => (
					<S.FilterTab
						key={tab.tag}
						data-qa={`filter-tab-${tab.tag.toLowerCase()}`}
						isActive={selectedTags.includes(tab.tag)}
						onClick={() => handleOnClick(tab)}
					>
						{tab.text}
					</S.FilterTab>
				))}
			</S.Wrapper>
			{selectedTags.includes('Spam') && (
				<S.SpanMessage data-qa="spam-warning-message">
					{CONVERSATIONS_FILTER_STRINGS.SPAM_MESSAGE}
				</S.SpanMessage>
			)}
		</>
	);
});

ConversationsFilter.displayName = 'ConversationsFilter';
export { ConversationsFilter };
